import TransferAsset from "./TransferAsset";
import { useEffect, useRef, useState } from "react";
import RatingInfo from "./RatingInfo";
import { useDispatch, useSelector } from "react-redux";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { setTransferAssetDetails } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { getFileName, formatPrice } from "utils";
import { v1 as uuid } from "uuid";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { useNavigate, useParams } from "react-router-dom";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { CONSTANTS } from "client/utils/constants";
import { APIToReact } from "Service/Transfer/ObjectStructure";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import RejectedBee from "../../../../../../assets/images/PenndingApproval/Rejected Bee.png";
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import navOperations from "redux/Navigation/operations";
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import { setDeleteCartOrder } from "Store/OrderManagement/Order/OrderAction";
import { setTransferOrderById } from "Store/Transfer/Transfer/TransferOrderByIdAction";
import { IAssets } from "Model/IAssets";
import moment from "moment";

const initialState: IAssets = {
  requestIndex: 0,
  requestType: CONSTANTS.TRANSFER,
  assetIndex: 1,
  assetNumber: '',
  unitNumber: '',
  model: '',
  costCenterNo: '',
  manufacturerName: '',
  dateDisposed: '',
  modelYear: '',
  color: '',
  description: '',
  serialNumber: '',
  licensePlateNumber: '',
  monthlyAmount: '',
  monthRemaining: 0,
  equipmentClass: '',
  equipmentClassDesc: '',
  eqStatus: '',
  eqStatusDesc: '',
  netBookedValue: '',
  odometerHourMeter: '',
  estimatedDispositionPrice: 0,
  conditionRating: '',
  conditionComment: '',
  openCloseAccordian: false,
  assetError: '',
  odometerHourMeterError: '',
  overallConditionError: '',
  overallConditionCommentError: '',
  estimatedDispositionPriceError: '',
  toolTip: '',
  isExist: false,
  isValid: false,
  isAttachmentsRequired: false,
  attachments: [],
  reactivationColorError: '',
  currentLicensePlateNo: '',
  currentLicensePlateError: '',
  reactivationComments: '',
  reactivationCommentsError: '',
  attachmentsError: '',
  receivingCostCenter: null,
  receivingCostCenterError: '',
}

const assetFieldList = [
  "assetNumber",
  "odometerHourMeter",
  "attachments",
  'conditionRating',
  'conditionComment',
]

const TransferAssetContainer = (props: any) => {
  const {
    isRevertChanges,
    setIsRevertChanges,
    setShowCart,
    setSuccessAlert,
    setShowCartClicked,
    setShowCreateRequisition,
    quantity,
    mobile,
    onCancelClick,
    showCart,
  } = props;

  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const navigate = useNavigate();

  const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
  const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchSetIsOrderCanceled = pendingOrderOperations.dispatchSetIsOrderCanceled(dispatch);

  const [assetDetailList, setAssetDetailList] = useState<any>([initialState]);
  const [isAssetBtnClicked, setIsAssetBtnClicked] = useState(false);
  const [attachmentsList, setAttachmentsList] = useState<any>([]);
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [isEditOrder, setIsEditOrder] = useState(false)
  const [isCancelRequestClicked, setIsCancelRequestClicked] = useState(false)
  const [isAssetNumberValid, setIsAsserNumberValid] = useState(true);
  const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);
  const [attachmentError, setAttachmentError] = useState<string>("");
  const [addNewAssetAlert, setAddNewAssetAlert] = useState(false);

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
  });

  const {
    orderDetails,
    assetDetails,
    cartAssets,
    docList,
    assetError,
    transferAssets,
    transferRequests,
    transferOrderByIdData,
    getUserDetails,
    isOrderCanceled,
    headerNav,
    cartOrderDelete
  }: any = useSelector((state?: any) => ({
    orderDetails: state.TransferReducer.orderDetails,
    assetDetails: state.AssetNumber.assetDetails,
    cartAssets: state.TransferReducer.cartAssets,
    docList: state.UploadAttachmentsReducer.list,
    assetError: state.AssetNumber.assetError,
    transferRequests: state.TransferReducer.transferRequests,
    transferAssets: state.TransferReducer.assets,
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    getUserDetails: state.UserProfile.getUserDetails,
    isOrderCanceled: state.PendingOrder.isOrderCanceled,
    headerNav: state.nav.headerNav,
    cartOrderDelete: state.OrderReducer.cartOrderDelete
  }));

  useEffect(() => {
    setAttachmentsList(docList);
  }, [docList]);

  let { id } = useParams(); //this id is orderId for draft mode

  useEffect(() => {
    if (id) {
      setShowCartClicked(true);
      setShowCart(true);
      updateAllState();
      setIsEditOrder(true);
    } else {
      setIsEditOrder(false);
      // If transferAssets already has data (e.g. returning after submit-time validation failure),
      // initialize from it so assetError values are immediately visible in the Asset# input fields.
      // Preserve the existing assetIndex from each asset so changedIndex matching in AssetNumber-Container stays intact.
      if (transferAssets?.length > 0) {
        const assetsWithIndex = transferAssets.map((a: any) => ({ ...a }));
        setAssetDetailList(assetsWithIndex);
      } else {
        let assetDetailListTemp = [];
        for (let i = 1; i <= quantity; i++) {
          const asset: IAssets = JSON.parse(JSON.stringify(initialState));
          asset.assetIndex = i - 1;
          assetDetailListTemp.push(asset);
        }
        setAssetDetailList(assetDetailListTemp);
        dispatch(TransferAction.setAssetData(assetDetailListTemp));
      }
      setDocumentList(docList)
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setAddNewAssetAlert(false)
    }, 3000)
  }, [addNewAssetAlert])

  useEffect(() => {
    if (cartAssets?.length) {
      let tempAssets = assetDetailList?.length > 0 ? assetDetailList : [];

      //check if asset exist in cart
      cartAssets?.forEach((asset: any) => {
        tempAssets.forEach((childAsset: any) => {
          if (childAsset?.assetNumber === asset?.assetNumber) {
            childAsset.isExist = asset.isExist;
          }
        });
      });

      //delete asset from list when deleted from cart
      if (cartAssets?.length === transferAssets?.length && transferAssets.length != assetDetailList?.length) {
        const newTempAsset = JSON.parse(JSON.stringify(tempAssets))
        tempAssets = [];
        cartAssets?.forEach((asset: any) => {
          const temp = newTempAsset.filter((item: any) => item?.assetNumber === asset?.assetNumber);
          if (temp) {
            tempAssets.push(temp[0]);
          }
        });
      }
      setAssetDetailList(tempAssets);
    }
  }, [cartAssets])

  // sync assetError from transferAssets so submit-time validation errors appear in the Asset# input
  useEffect(() => {
    if (transferAssets?.length) {
      let tempAssets = assetDetailList?.length > 0 ? [...assetDetailList] : [];
      let hasChanges = false;
      tempAssets.forEach((childAsset: any) => {
        const matched = transferAssets.find((a: any) => a?.assetNumber == childAsset?.assetNumber);
        if (matched && matched.assetError !== undefined && matched.assetError !== childAsset.assetError) {
          childAsset.assetError = matched.assetError;
          hasChanges = true;
        }
      });
      if (hasChanges) {
        setAssetDetailList([...tempAssets]);
      }
    }
  }, [transferAssets])

  useEffect(() => {
    if (isRevertChanges && id) {
      updateAllState();
      setIsRevertChanges(false);
    }
  }, [isRevertChanges]);

  const updateAllState = () => {
    let assetDetailListTemp: any = [];

    let assetsListTemp = transferAssets?.length > 0 ? JSON.parse(JSON.stringify(transferAssets)) : []
    assetsListTemp.forEach((asset: any, index: any) => {
      asset.assetIndex = index;
      assetDetailListTemp.push(asset);
    });

    if (assetsListTemp.length === 0) {
      for (let i = 1; i <= quantity; i++) {
        const asset: IAssets = JSON.parse(JSON.stringify(initialState));
        asset.assetIndex = i - 1;
        assetDetailListTemp.push(asset);
      }
    } else {
      setShowCart(true);
      setIsEditOrder(true);
      setIsAssetBtnClicked(false);
      if (mobile) {
        setShowCreateRequisition(false)
        setShowCartClicked(false)
      }
      else {
        setShowCartClicked(true)
        setShowCreateRequisition(true)
      }
    }
    dispatch(TransferAction.setAssetData(assetsListTemp));
    setAssetDetailList(assetDetailListTemp);
  }

  useEffect(() => {
    let isUpdated = false;
    assetDetailList.forEach((item: any) => {
      const findAsset = transferAssets?.filter((i: any) => i?.assetNumber === item?.assetNumber);
      if (findAsset?.length > 0) {
        const tempAsset = findAsset[0];
        assetFieldList.forEach(element => {
          if (item[element] != tempAsset[element]) {
            isUpdated = true;
          }
        })
        if( item?.receivingCostCenter?.value != tempAsset?.receivingCostCenter?.value) {
          isUpdated = true
        }
        if (item?.attachments?.length != tempAsset?.attachments?.length) {
          isUpdated = true
        }
      } else {
        isUpdated = true;
      }
    });
    dispatch(TransferAction.setIsCartNotUpdated(isUpdated));
  }, [assetDetailList])

  //This useEffect is for the data issue of getting "-." in Status and class.  
  useEffect(() => {
    if (assetDetails?.assetNumber) {
      let assetvalues: any = assetDetails
      let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
      assetDetailListTemp?.forEach((assetItem: any) => {
        if (assetItem?.assetNumber == assetDetails?.assetNumber) {

          if (assetvalues?.eqStatusDesc !== undefined) {
            assetItem.eqStatusDesc = (assetvalues?.eqStatusDesc !== "-." && assetvalues?.eqStatusDesc !== null && assetvalues?.eqStatusDesc !== "") ? assetvalues?.eqStatusDesc : "-"
          }
          if (assetvalues?.equipmentClassDesc !== undefined) {
            assetItem.equipmentClassDesc = (assetvalues?.equipmentClassDesc !== "-." && assetvalues?.equipmentClassDesc !== null && assetvalues?.equipmentClassDesc !== "") ? assetvalues?.equipmentClassDesc : "-"
          }

          if (assetvalues?.manufacturerName !== undefined) {
            assetItem.manufacturerName = (assetvalues?.manufacturerName !== "." && assetvalues?.manufacturerName !== null && assetvalues?.manufacturerName !== "") ? assetvalues?.manufacturerName : "-"
          }
          assetItem.assetError = "";
          assetItem.unitNumber = assetDetails.unitNumber;
          assetItem.modelYear = assetDetails.modelYear;
          assetItem.description = assetDetails.description;
          assetItem.serialNumber = assetDetails.serialNumber;
          assetItem.licensePlateNumber = assetDetails.licensePlateNumber;
          assetItem.monthlyAmount = assetDetails.monthlyAmount;
          assetItem.monthRemaining = assetDetails.monthRemaining;
          assetItem.netBookedValue = assetDetails.netBookedValue;
          assetItem.glCategory = assetDetails.glCategory;
          assetItem.isOdometerRequired = assetDetails.isOdometerRequired;
          assetItem.dateAcquired = assetDetails.dateAcquired ? moment(assetDetails.dateAcquired).format('MM/DD/YYYY') : '-';
          assetItem.disposeGainLoss = assetDetails?.disposeGainLoss;
          assetItem.acquisitionCode = assetDetails?.acquisitionCode;
          assetItem.accountObject = assetDetails?.accountObject;
          assetItem.acquisitionCost = assetDetails?.acquisitionCost;
          assetItem.lifeMonths = assetDetails?.lifeMonths;
          assetItem.leasedvsOwned = assetDetails?.leasedvsOwned;
          assetItem.showAssetStatus = assetDetails?.showAssetStatus;
          assetItem.costCenterNo = assetDetails?.costCenterNo;
          assetItem.model = assetDetails?.model;
          assetItem.odometerHourMeter = assetDetails?.glCategory?.toLowerCase()?.includes("trailer") ? "0" : "";
          assetItem.dateDisposed = assetDetails.dateDisposed ? moment(assetDetails.dateDisposed).format('MM/DD/YYYY') : '-';
          assetItem.disposalDate = assetDetails.dateDisposed ? new Date(assetDetails.dateDisposed) : new Date()
        }
      });
      setAssetDetailList(assetDetailListTemp)
    }
  }, [assetDetails])

  useEffect(() => {
    if ((isOrderCanceled.approval || cartOrderDelete) && isCancelRequestClicked) {
      setIsCancelRequestClicked(false);
      let decriptionTxt = (
        <p>Order Cancelled Successfully</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: RejectedBee,
        title: "CANCEL ORDER",
        isDialogVisible: true,
        isTitleWarning: false,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          dispatch(RequisitionAction?.setIsChangesOccured(false))
          dispatch(TransferAction.setIsChangesOccuredInCart(false))
          dispatchSetIsOrderCanceled(false)
          resetAllAssetOrderData(dispatch);
          dispatchNav(headerNav);
          navigate('/ordermanagement')
          dispatch(setDeleteCartOrder(false))
          dispatch(setTransferOrderById({}))
          dispatch(TransferAction.setAfeOrderByIdData({}))
        },
      });
    } else if ((!isOrderCanceled.approval || !cartOrderDelete) && isCancelRequestClicked) {
      setIsCancelRequestClicked(false);
      let decriptionTxt = (
        <div>
          <p>Order Cancelled Failed</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: RejectedBee,
        title: "CANCEL ORDER",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setDeleteCartOrder(false))
        },
      });
    }
  }, [isOrderCanceled?.approval, cartOrderDelete])

  const [addToCart, setAddToCart] = useState(false);
  const [documentList, setDocumentList] = useState<any>([]);
  const TransferAssetFieldRef = useRef<any>([]);

  const isHourMeterField = (asset: any) => {
    if (asset?.isOdometerRequired) {
      return false;
    }
    return asset?.glCategory?.toLowerCase()?.includes("mower");
  }

  const getOdometerLabel = (asset: any) => {
    let label;
    if (asset?.isOdometerRequired) {
      label = "Mileage"
    } else if (asset?.glCategory?.toLowerCase()?.includes("mower")) {
      label = "Hour Meter"
    } else if ((asset?.assetNumber?.length && asset?.assetNumber && isAssetBtnClicked && !asset?.assetError) || (asset.isOdometerRequired != undefined || asset.isOdometerRequired == false)) {
      label = "Odometer / Meter"
    } else {
      label = "Odometer / Hour Meter"
    }
    return label
  }

  const getVinSerialLabel = (asset: any) => {
    let label = "";
    if (asset?.isOdometerRequired && asset?.assetNumber) {
      label = "Vin #"
    } else if (asset?.assetNumber) {
      label = "Serial #"
    } else {
      label = "VIN / Serial #"
    }
    return label;
  }

  useEffect(() => {
    TransferAssetFieldRef?.current[0]?.focus();
  }, [])

  // Validation functions for each field
  const validateAsset = (assetItem: any) => {
    const assetItemTemp = JSON.parse(JSON.stringify(assetItem))
    let isValid = false;
    if (!assetItemTemp?.assetNumber) {
      assetItemTemp.assetError = "Please enter Valid Asset #"
    } else if (assetItemTemp?.assetNumber?.length > 15) {
      assetItemTemp.assetError = "Please enter Asset number less than 15 digits."
    } else if (assetItemTemp.assetError?.length === 0) {
      assetItemTemp.assetError = "Click 'Get Asset Info' button to validate";
      isValid = true;
    }
    return { isValid, assetItemTemp };
  }

  const validateOdometerHourMeter = (asset: any) => {
    let error = "";
    if (!asset.odometerHourMeter) {
      error = "Please enter " + getOdometerLabel(asset)?.toLowerCase();
    } else if (orderDetails?.odometerHourMeter?.length > 9) {
      error = "Please enter " + getOdometerLabel(asset)?.toLowerCase() + " less than 9 digits";
    }
    return error;
  };

  const validateConditionComment = (asset: any) => {
    let error = "";
    if (asset.conditionRating <= 3 && !asset.conditionComment) {
      error = "Please add overall condition comment";
    } else if (asset?.conditionComment?.length > 200) {
      error = "Please enter comment less than 200 character";
    }
    return error;
  };

  const validateStarCondition = (asset: any) => {
    let error = "";
    if (asset.conditionRating === 0 || asset.conditionRating === null || asset.conditionRating === '') {
      error = "Please select at least one star";
    }
    return error;
  };

  const validateReceivingCostCenter = (asset: any) => {
    let error = "";
    if (!asset.receivingCostCenter || !asset.receivingCostCenter.value) {
      error = "Please select a cost center";
    } else if (asset.receivingCostCenter?.label?.split(" ").join("") === orderDetails.selectedBranch?.label?.split(" ").join("")) {
      error = "Please select another cost center"
    } else {
      error = "";
    }
    return error;
  };

  const validate = (assets?: IAssets) => {
    let assetItem = JSON.parse(JSON.stringify(assets))
    assetItem.assetError = validateAsset(assetItem).isValid ? "" : validateAsset(assetItem).assetItemTemp.assetError;
    assetItem.odometerHourMeterError = validateOdometerHourMeter(assetItem);
    assetItem.overallConditionCommentError = validateConditionComment(assetItem);
    assetItem.overallConditionError = validateStarCondition(assetItem);
    assetItem.receivingCostCenterError = validateReceivingCostCenter(assetItem);
    let isValid = true;
    if (assetItem?.odometerHourMeterError
      || assetItem?.overallConditionCommentError
      || assetItem?.overallConditionError
      || assetItem?.assetError
      || assetItem?.receivingCostCenterError) {
      isValid = false;
    }
    return { assetItem, isValid };
  }

  useEffect(() => {
    if (assetDetails?.assetNumber && assetError?.assetError == '' && assetDetails?.glCategory !== "Trailers") {
      TransferAssetFieldRef?.current[1]?.focus();
    }
  }, [assetError])

  const onClickAdd = () => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    let nextAssetIndex = 0;
    assetDetailListTemp.forEach((item: any) => {
      if (item.assetIndex > nextAssetIndex) {
        nextAssetIndex = item.assetIndex;
      }
    });
    nextAssetIndex = nextAssetIndex + 1;
    setAddNewAssetAlert(true)
    const asset: any = initialState;
    asset.assetIndex = nextAssetIndex;
    assetDetailListTemp.push(asset);
    setAssetDetailList(assetDetailListTemp);
  }

  const onClickDelete = (asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    if (assetDetailList?.length == 1) {
      onCancelClick(true);
    } else {
      let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
      const list = assetDetailListTemp?.filter((item: any) => item.assetIndex !== asset.assetIndex);
      list?.map((item?: any) => {
        if (item?.assetIndex > asset?.assetIndex) {
          item.assetIndex = item.assetIndex - 1;
        }
      })

      const transferAssetslist = transferAssets?.filter((item: any) => item.assetIndex !== asset.assetIndex);
      transferAssetslist?.map((item?: any) => {
        if (item?.assetIndex > asset?.assetIndex) {
          item.assetIndex = item.assetIndex - 1;
        }
      })
      setAssetDetailList(list);
      dispatch(TransferAction.setAssetData(transferAssetslist));
    }
  }

  const saveCostCenter = (assetList: any) => {
    const transferRequestsTemp = transferRequests?.length > 0 ? JSON.parse(JSON.stringify(transferRequests)) : []
    assetList.forEach((element: any) => {
      //checking if the receiving branch cost center already added to transferRequests
      let isValidTransferRequest = true
      transferRequestsTemp.forEach((request: any) => {
        if (request?.costCenter?.value === element?.receivingCostCenter?.value) {
          isValidTransferRequest = false
        }
      })
      //if unique receiving branch than adding it to transferRequests
      if (isValidTransferRequest) {
        //for adding unique requestIndex to new receiving branch
        let nextRequestIndex = 0;
        transferRequestsTemp.forEach((item: any) => {
          if (item?.requestIndex > nextRequestIndex) {
            nextRequestIndex = item?.requestIndex;
          }
        });
        nextRequestIndex = nextRequestIndex + 1;

        const assignmentTransfer = {
          disabled: false,
          group: null,
          key: "5",
          label: "No Change to Current Assignment",
          selected: false,
          text: "No Change to Current Assignment",
          value: "5"
        }
        transferRequestsTemp.unshift({
          costCenter: element?.receivingCostCenter,
          assignmentTransfer: assignmentTransfer,
          requestIndex: transferRequestsTemp?.length ? nextRequestIndex : 0,
          requestType: CONSTANTS.TRANSFER,
          expand: true,
          collaps: true
        })
      }
    });
    dispatch(TransferAction.setTransferRequestData(transferRequestsTemp))
    return transferRequestsTemp
  }

  const handleClickCart = () => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : []
    let validatedAssetList: any = [];
    let isValid = true;
    assetDetailListTemp?.forEach((assetItem: any) => {
      let asset = validate(assetItem);
      if (asset?.assetItem) {
        validatedAssetList.push(asset.assetItem);
        if (isValid) isValid = asset.isValid;
      }
    });
    setAssetDetailList(validatedAssetList);

    if (isValid) {
      if (transferOrderByIdData?.orderStatus == "Saved") {
        dispatch(TransferAction.setIsChangesOccuredInCart(true))
      }
      setShowCart(true);
      setSuccessAlert(true)
      if (mobile) {
        setShowCreateRequisition(false)
        setShowCartClicked(false)
      }
      else {
        setShowCreateRequisition(true)
        setShowCartClicked(true)
      }

      const transferRequestsTemp = saveCostCenter(validatedAssetList);

      // Set requestIndex for each asset based on transferRequests
      validatedAssetList.forEach((assetItem: any) => {
        assetItem.requestIndex = transferRequestsTemp?.find(
          (request: any) => request?.costCenter?.value === assetItem?.receivingCostCenter?.value
        )?.requestIndex;
        assetItem.requestType = CONSTANTS.TRANSFER;
        assetItem.hide = validatedAssetList.length !== 1
        assetItem.isValid = true
        assetItem.isExist = true;
      });

      props.setSuccessAlert(true);
      dispatch(TransferAction.setAssetData(validatedAssetList))
      dispatch(TransferAction.setAssetCartData(validatedAssetList))
      setIsAssetBtnClicked(false);
      setAddToCart(false);

      TransferAssetFieldRef?.current[0]?.focus();
    }
  }

  const handleCommentchanges = (item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp?.forEach((assetItem: any) => {
      if (assetItem?.assetIndex === asset?.assetIndex) {
        assetItem.conditionComment = item?.target?.value;
        assetItem.overallConditionCommentError = validateConditionComment(assetItem)
        assetItem.isValid = validate(assetItem)?.isValid;
      }
    });
    setAssetDetailList(assetDetailListTemp)
    TransferAssetFieldRef?.current[4]?.focus();
  }

  const onChangeOdometerHourMeter = (item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp?.forEach((assetItem: any) => {
      if (assetItem?.assetIndex === asset?.assetIndex) {
        const value = item?.target?.value;
        // Different regex for Hour Meter (integer only) vs Mileage/Odometer (1 decimal)
        const hourMeterRegex = /^\d{0,9}$/; // Integer only for Hour Meter
        const odometerRegex = /^\d{0,8}(\.\d{0,1})?$/; // Up to 1 decimal for Mileage/Odometer
        const regex = isHourMeterField(assetItem) ? hourMeterRegex : odometerRegex;
        
        if (regex.test(value) || value === '') {
          assetItem.odometerHourMeter = value;
          assetItem.odometerHourMeterError = validateOdometerHourMeter(assetItem);
          assetItem.isValid = validate(assetItem)?.isValid;
        }
      }
    });
    setAssetDetailList(assetDetailListTemp)
    TransferAssetFieldRef?.current[2]?.focus();
  }

  const formatOdometerOnBlur = (event: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp?.forEach((assetItem: any) => {
      if (assetItem?.assetIndex === asset?.assetIndex) {
        const value = event.target.value;
        if (value && value !== '') {
          if (isHourMeterField(assetItem)) {
            // Hour Meter: No formatting, keep as integer
            assetItem.odometerHourMeter = value;
          } else {
            assetItem.odometerHourMeter = parseFloat(value).toFixed(1);
          }
        }
      }
    });
    setAssetDetailList(assetDetailListTemp)
  }

  const informationList = [
    {
      text: 'Please ensure maintenance files stays with the vehicle or equipment'
    },
    {
      text: 'Please ensure fuel cards remains with the vehicle or equipment'
    }
  ]

  const informationConditionList = [
    {
      text: 'Condition rating needs to be accurate and detailed if repairs are recommended/required'
    },
    {
      text: 'Failure to report accurate needed repairs/condition will result in asset being returned to sending branch or sending branch will be responsible for cost of repairs'
    }
  ]

  const onChangeRating = (rating: any, asset: any) => {
    if (rating <= 3) {
      TransferAssetFieldRef?.current[3]?.focus();
    }
    else {
      TransferAssetFieldRef?.current[4]?.focus();
    }

    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp?.forEach((assetItem: any) => {
      if (assetItem?.assetIndex === asset?.assetIndex) {
        assetItem.conditionRating = rating;
        assetItem.overallConditionError = validateStarCondition(assetItem);
        assetItem.isValid = validate(assetItem)?.isValid;
      }
    });
    setAssetDetailList(assetDetailListTemp)
  }

  const onClicktLinkAttachment = (e: any, index: any) => {
    e.preventDefault();
    e.stopPropagation();
    const attachmentButton: any = isAttachmentBtnClicked;
    attachmentButton[index] = !attachmentButton[index];
    setIsAttachmentBtnClicked(JSON.parse(JSON.stringify(attachmentButton)))
  }

  const onCloseLinkAttachment = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setIsAttachmentBtnClicked([])
  }

  const onChangeLinkAttachment = (event: any, attachment: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    event?.preventDefault();
    const asset = reason;
    if (event?.target?.checked) {
      if (!asset.attachments?.map((x: any) => x.fileName).includes(attachment.fileName)) {
        asset.attachments = [...(asset.attachments || []), attachment];
      }
    } else {
      asset.attachments = [
        ...asset.attachments.filter((x: any) => x.fileName !== attachment.fileName),
      ];
    }
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem: any) => {
      if (assetItem?.assetIndex === asset?.assetIndex) {
        assetItem.attachments = asset?.attachments;
      }
    });
    setAssetDetailList(assetDetailListTemp)
  }

  const isUploaded = (name: string) =>
    attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

  // To upload attachments
  const onUploadClick = (fileList: Array<File>) => {
    dispatch(RequisitionAction?.setIsChangesOccured(true))
    setAttachmentError("");
    const filteredList = [
      ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
    ];
    if (filteredList.length > 0 && filteredList.length <= 5) {
      setAttachmentError("");
      let totalSize = 0;
      filteredList.forEach((file: File) => {
        totalSize = totalSize + (file.size || 0);
      });
      if (totalSize <= 5000000) {
        setAttachmentError("");
        const formData = new FormData();
        formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

        for (let i = 0; i < filteredList.length; i++) {
          formData.append("Files", filteredList[i] as any);
        }
        dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
      } else {
        setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
      }
    } else if (fileList.length > 5) {
      setAttachmentError(
        "Please Upload files without exceeding maximum limit of 5 files"
      );
    } else {
      if (fileList.length > 0 && !filteredList.length) {
        setAttachmentError("All files are uploaded try to add new files");
      } else {
        setAttachmentError("Choose at least 1 file to upload");
      }
    }
  };

  const getLinkedAttachmentsCount = (asset: any) => {
    return asset.attachments?.length ? asset.attachments?.length : 0
  }

  const onRemoveAttachment = (index: any) => {
    const findattachment = attachmentsList?.find((_attachment: any, i: any) => index === i);
    const assetArr = [];
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    if (findattachment) {
      assetDetailListTemp?.attachments?.forEach((assetVal: any) => {
        const findAttch = (assetVal?.fileName === findattachment?.fileName);
        if (findAttch) {
          assetArr.push(assetVal)
        }
      })
      transferAssets?.forEach((asset: any) => {
        const attachment = asset?.attachments;
        const findAttchInCartAsset = attachment?.find((attch: any) => attch?.fileName === findattachment?.fileName);
        if (findAttchInCartAsset) {
          assetArr.push(asset)
        }
      })
    }
    if (assetArr.length) {
      setAttachmentError("The attachment file cannot be deleted. File linked to the item.");
    }
    else {
      dispatch(RequisitionAction?.setIsChangesOccured(true))
      const tempAssetsDetails = assetDetails;
      if (tempAssetsDetails?.attachments?.length) {
        tempAssetsDetails.attachments = tempAssetsDetails?.attachments?.filter((attach: any) => attach?.fileName !== findattachment.fileName)
      }
      dispatch(setTransferAssetDetails(tempAssetsDetails));
      const newArr = attachmentsList.slice();
      newArr.splice(index, 1);
      const assets = transferAssets.map((asset: any) => {
        const attachments = asset?.attachments?.filter((attach: any) => !!newArr?.find((doc: any) => doc.fileName === attach.fileName))
        return { ...asset, attachments };
      })
      const newFileList = JSON.parse(JSON.stringify(documentList));
      newFileList.splice(index, 1);
      setDocumentList(newFileList);
      dispatch(TransferAction.setAssetData(assets));
      dispatchRemoveAttachment(newArr);
      setAttachmentError("");
    }
  }

  const revertChangesOnClick = () => {
    APIToReact({
      dispatch,
      transferOrderByIdData
    })
    setIsRevertChanges(true);
  }

  const popupPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    if (transferOrderByIdData?.orderStatus == "Saved") {
      const deleteDraftOrder = {
        orderId: transferOrderByIdData?.orderId,
        comments: comment,
        savedBy: getUserDetails?.emailId
      };
      dispatchGetDeleteCartOrderById(deleteDraftOrder)
    } else {
      cancelOrderRequest({ orderId: transferOrderByIdData?.orderId, savedBy: getUserDetails?.emailId, comments: comment });
    }
    hideDialog();
  };

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }
  const cancelRequestOnClick = () => {
    setIsCancelRequestClicked(true);
    const cancelOrdersubtext = (
      <div>
        <p>Are you sure you want to cancel the Order</p>
        <p>
          <b>LEADR Order # : </b>{id}
        </p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      popupOutlinebtnOnclick: () => {
        hideDialog();
        setIsCancelRequestClicked(false);
      }
    });
  }

  return (
    <TransferAsset
      isAssetBtnClicked={isAssetBtnClicked}
      setIsAssetBtnClicked={setIsAssetBtnClicked}
      handleCommentchanges={handleCommentchanges}
      onChangeOdometerHourMeter={onChangeOdometerHourMeter}
      handleClickCart={handleClickCart}
      informationList={informationList}
      informationConditionList={informationConditionList}
      onChangeRating={onChangeRating}
      assetDetailList={assetDetailList}
      setAssetDetailList={setAssetDetailList}
      onClickAdd={onClickAdd}
      onClickDelete={onClickDelete}
      addToCart={addToCart}
      documentList={documentList}
      setDocumentList={setDocumentList}
      onClicktLinkAttachment={onClicktLinkAttachment}
      onCloseLinkAttachment={onCloseLinkAttachment}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      attachmentsList={attachmentsList}
      onChangeLinkAttachment={onChangeLinkAttachment}
      attachmentError={attachmentError}
      onUploadClick={onUploadClick}
      getLinkedAttachmentsCount={getLinkedAttachmentsCount}
      onRemoveAttachment={onRemoveAttachment}
      setAttachmentError={setAttachmentError}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      isEditOrder={isEditOrder}
      transferOrderByIdData={transferOrderByIdData}
      cancelRequestOnClick={cancelRequestOnClick}
      revertChangesOnClick={revertChangesOnClick}
      getOdometerLabel={getOdometerLabel}
      getVinSerialLabel={getVinSerialLabel}
      TransferAssetFieldRef={TransferAssetFieldRef}
      setIsAsserNumberValid={setIsAsserNumberValid}
      isHourMeterField={isHourMeterField}
      formatOdometerOnBlur={formatOdometerOnBlur}
      setAddToCart={setAddToCart}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      docList={docList}
      addNewAssetAlert={addNewAssetAlert}
      setAddNewAssetAlert={setAddNewAssetAlert}
      validate={validate}
      validatereceivingCostCenter={validateReceivingCostCenter}
      transferAssets={transferAssets}
      showCart = {showCart}
    />
  )
}

export default TransferAssetContainer;
